import {match} from 'ts-pattern';

import type {AdvertisementPreviewPlatform} from '@dms/api/sales';

type DescriptionFormat = AdvertisementPreviewPlatform['description']['format'];

export function convertPlatformDescriptionToHtml(value: string, format: DescriptionFormat): string {
  const escaped = value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const lines = format === 'markdown' ? escaped.split(/\r?\n/) : escaped.split(/\\\\|\r?\n/);
  const output: string[] = [];
  let listType: 'ul' | 'ol' | null = null;
  let paragraphOpen = false;

  for (const line of lines) {
    const bold = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    const formatted =
      format === 'markdown'
        ? bold
            .replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>')
            .replace(/\b_([^_]+)_\b/g, '<em>$1</em>')
        : bold;
    const bullet =
      format === 'markdown' ? /^(?:-|\*) (.*)$/.exec(formatted) : /^\* (.*)$/.exec(formatted);
    const numbered = format === 'mobile_de_markup' ? null : /^\d+\. (.*)$/.exec(formatted);
    const nextListType = match({bullet: !!bullet, numbered: !!numbered})
      .with({bullet: true}, () => 'ul' as const)
      .with({numbered: true}, () => 'ol' as const)
      .otherwise(() => null);

    if (listType && listType !== nextListType) {
      output.push(`</${listType}>`);
    }
    if (nextListType && listType !== nextListType) {
      if (paragraphOpen) {
        output.push('</p>');
        paragraphOpen = false;
      }
      output.push(`<${nextListType}>`);
    }
    if (nextListType) {
      output.push(`<li>${bullet?.[1] ?? numbered?.[1]}</li>`);
    } else if (format === 'markdown') {
      if (!formatted) {
        // eslint-disable-next-line max-depth -- Pre-existing violation
        if (paragraphOpen) {
          output.push('</p>');
        }
        paragraphOpen = false;
      } else {
        // eslint-disable-next-line max-depth -- Pre-existing violation
        if (!paragraphOpen) {
          output.push('<p>');
        } else {
          output.push('<br>');
        }
        output.push(formatted);
        paragraphOpen = true;
      }
    } else if (formatted || output.length === 0) {
      if (output.length > 0) {
        output.push('<br>');
      }
      output.push(formatted);
    }
    listType = nextListType;
  }
  if (listType) {
    output.push(`</${listType}>`);
  }
  if (paragraphOpen) {
    output.push('</p>');
  }
  return output.join('');
}
